import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import useToggle from '../../Hooks/useToggle';
import heroThumb from '../../assets/images/partner-ship-image.png';
import BackToTop from '../BackToTop';
import FooterHomeThree from '../Footer/FooterHomeThree';
import HeaderNews from '../Header/HeaderNews';
import HeroNews from '../Header/HeroNews';
import Drawer from '../Mobile/Drawer';
import AppsFAQ from './AppsFAQ';

function OurApps() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Find the perfect software solution for your business needs with OTO's range of SaaS apps. From inventory management to hotel management, our apps are designed to streamline your operations and boost productivity. Browse our apps listing page now!"
                />
                <meta property="og:image" content={heroThumb} />

                <title>OTO's Business Apps for Inventory, Finance, and Hotel Management</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <HeroNews
                title="Our Apps"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/apps', title: 'Apps' },
                ]}
            />

            <div
                className="container pt-90 pb-4 text-center"
                style={{ fontSize: '18px', lineHeight: '29px' }}
            >
                <h3 className="mb-4">Discover the Best SaaS Apps for Your Business with OTO</h3>
                <p className="mb-3">
                    Explore our range of SaaS apps designed to help you manage your business more
                    efficiently.
                    <br /> Our apps are perfect for businesses of all sizes and industries, from
                    small startups to large enterprises.
                </p>
                <p>
                    Our SaaS apps are designed to meet the unique needs of various industries,
                    <br />
                    including inventory management, finance, POS, and hotel management.
                </p>
            </div>

            <div className="container pt-20 pb-80" style={{ fontSize: '18px', lineHeight: '29px' }}>
                <div className="row">
                    <div className="col-md-3 mb-3">
                        <div className="single-app-box">
                            <h2>Backoffice</h2>
                            <p>
                                Manage your finances, with features like automated invoicing,
                                payment tracking, and expense management. Maximize your cash flow
                                and minimize financial errors with OTO.
                            </p>

                            <Link to="/apps/backoffice">
                                Learn More <i className="fal fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="single-app-box bg-light">
                            <h2>Frontdesk</h2>
                            <p>
                                Designed specifically for the hospitality industry, with features
                                like online booking, guest management, and room assignment
                                tracking.Enhance your guests' experience and boost your revenue.
                            </p>
                            <Link to="/apps/frontdesk">
                                Learn More <i className="fal fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="single-app-box">
                            <h2>POS</h2>
                            <p>
                                Designed for businesses of all sizes, with features like real-time
                                sales tracking, easy inventory management, table management and
                                waiter order taking
                            </p>

                            <Link to="/apps/pos">
                                Learn More <i className="fal fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-3 mb-3">
                        <div className="single-app-box bg-light">
                            <h2>Inventory</h2>
                            <p>
                                This app helps you manage your inventory more efficiently, with
                                features like real-time tracking, automated stock updates, and easy
                                order management
                            </p>

                            <Link to="/apps/inventory-management">
                                Learn More <i className="fal fa-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <AppsFAQ />

            <div className="container pt-80 pb-100 text-center">
                <p style={{ fontSize: '20px', lineHeight: '30px' }}>
                    With OTO's business apps, you can streamline your daily business operations,
                    boost productivity, and enhance customer satisfaction. Our software solutions
                    are customizable and scalable to meet your specific needs, whether you're
                    running a small business or a large enterprise.
                </p>
            </div>

            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default OurApps;
